module.exports = __webpack_public_path__ + "img/eyein-partner-videotron.eabaa56e.png";